module.exports = __webpack_public_path__ + "img/victoria-nacional.cfbf186c.png";